export default __webpack_public_path__ + "static/media/Seera-Thumb-2.22f803e1.png";